import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games ",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <TbShirtSport />,
    title: "Login to Account Manager",
    description: "Connect your Flames Account Manager using our secure login.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for the games.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your Flames Account Manager{" "}
        <Link
          target="_blank"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="https://play.google.com/store/apps/details?id=com.csec.flames"
        >
          Android
        </Link>{" "}
        or{" "}
        <Link
          target="_blank"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="https://apps.apple.com/us/app/calgary-flames-app/id6452839201"
        >
          Apple
        </Link>{" "}
        app. Reach out to Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "What happens with my initial investment?",
    description:
      "After selecting either, the $200 option or the $500 option, your initial investment turns into FlexClub credit that you can use to purchase regular season home game tickets for the Calgary Hitmen (WHL), Calgary Wranglers (AHL), or Calgary Roughnecks (NLL). These tickets are purchased at 15% off regular door price, with the added benefit of saving on ticket fees! Your confirmation of purchase will be provided via text.",
  },
  {
    title: "What games can I pick from?",
    description:
      "There are 78 total games to select from with the FlexClub credit, including 33 Hitmen games, 36 Wranglers games, and 9 Roughnecks games. All games available are listed on the redemption page.",
  },
  {
    title: "How do I redeem my account credit for tickets?",
    description: (
      <>
        FlexClub credit can be redeemed for game day tickets by clicking{" "}
        <Link
          target="_blank"
          href="https://flex2.seasonshare.com/calgary_flexbank"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          HERE
        </Link>
        . Log in to your account using your Account Manager credentials to view
        available game dates, and select the ones that best fit with your
        schedule.
        <ul>
          <li>
            <i>
              Note: Your account login information (email and password) remains
              the same across all teams' Account Manager platforms.
            </i>
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "How do I access my tickets?",
    description: (
      <>
        Once you have redeemed your FlexClub credit into tickets, you can access
        your game day tickets via Flames Account Manager or through the Calgary
        Flames App.
        <ul>
          <li>
            <i>
              Game dates and times are subject to change. Please ensure you are
              checking the team website for the most up-to-date information.
            </i>
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "How can I access my $50 Gift Card?",
    description: (
      <>
        Those who purchase the $500 option prior to September 24, will receive
        their $50 C of Red Gift Card digitally to their email inbox between
        September 25 and September 26. After September 26, C of Red Gift Cards
        will be processed every Friday. Please note, Gift Card emails will come
        from Calgary Sports and Entertainment (
        <Link
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="mailto:noreply@calgarysportsandentertainment.com"
        >
          noreply@calgarysportsandentertainment.com
        </Link>
        ) with the subject "Calgary Flames have sent you a gift card". Please
        ensure you check your spam/junk folder if you cannot locate it.
        <ul>
          <li>
            <b>
              Note: After the initial purchase of the $500 option, additional
              $50 C of Red gift cards will only be issued for full incremental
              purchases of $500 (e.g. accounts reloaded to the $500 level by
              using unused FlexClub credit will not be eligible for the $50 C of
              Red gift card).
            </b>
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "Can I forward my tickets?",
    description:
      "Yes. Once you have redeemed FlexClub credit for tickets, they are available to forward to other fans digitally. This can be done through Flames Account Manger and/or the Calgary Flames App.",
  },
  {
    title: "Can I exchange FlexClub tickets I've already purchased?",
    description: (
      <>
        No, once tickets have been purchased using your FlexClub credit for one
        game, they cannot be exchanged for another game.
      </>
    ),
  },
  {
    title: "How can I check my Available Credit balance?",
    description: (
      <>
        Log in to your account on the redemption page (
        <Link
          target="_blank"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="https://flex2.seasonshare.com/calgary_flexbank"
        >
          HERE
        </Link>
        ) and it will be located at the bottom right of your screen in a green
        box labeled "Available Credit".
      </>
    ),
  },
  {
    title: "Can I add FlexClub credit to my FlexClub account?",
    description: (
      <>
        Yes! FlexClub credit can be reloaded at any time by clicking{" "}
        <Link
          target="_blank"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="https://flex2.seasonshare.com/calgary_flexbank/purchase_credit"
        >
          HERE
        </Link>
        .
      </>
    ),
  },
  {
    title:
      "What happens if I don't have enough FlexClub credit to cover the cost of the tickets that I want?",
    description:
      "If you only have partial FlexClub account credit to cover a transaction, you can add your credit card to cover the remaining balance. Great news - you'll still save 15% on this transaction! You will then need to reload your FlexClub account to take advantage of the savings.",
  },
  {
    title: "Can I give FlexClub to a family member, friend or others?",
    description: (
      <>
        Yes! Please call our Customer Service team (
        <Link
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="tel:4037774646"
        >
          (403) 777-4646
        </Link>{" "}
        Option 1) for more information on purchasing FlexClub as a gift.
      </>
    ),
  },
  {
    title:
      "When is the last date to purchase FlexClub credit for the 2026/27 season?",
    description: "Wednesday, March 31, 2027 at 11:59PM MDT.",
  },
  {
    title:
      "Does my FlexClub credit carry over if I do not use it all in the 2026/27 regular season?",
    description:
      "Unused Account Credit will not carry over to the 2027/28 regular season.",
  },
];

export const CalgaryRegistrationTerms = () => (
  <>
    By creating an account you agree to receive email notifications regarding
    your purchase and to the{" "}
    <Link
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      target={"_blank"}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);

export const CalgaryCheckoutTerms = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/terms-of-use"
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
      href="https://www.attend.tech/privacy-policy"
    >
      Privacy Policy
    </Link>
    .
  </>
);
